// removed by extract-text-webpack-plugin
module.exports = {"filterDropdown":"TUtRU","btnFilter":"_3PG2d","dropdownMenu":"qiD6O","dropdownItem":"_395KK"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/search/components/orderPlanDropdown/styles.module.css
// module id = 218
// module chunks = 0